<app-page-header [title]="'Sample Types'" [subtitle]="'Manage sample types for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="sample_type_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="sample_type_search">Search sample type</label>
        </p-ifta-label>
        <p-button label="Add Sample Type" icon="pi pi-plus" (click)="this.openCreateSampleTypeDialog()" canManageSampleDefinitions
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.sampleTypes"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Default Weight (in grams)</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sampleType>
                <tr>
                    <td>{{ sampleType.name }}</td>
                    <td>{{ sampleType.defaultWeight }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View sample type"
                                      tooltipPosition="left"
                                      routerLink="/sample-types/sample-type/{{sampleType.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      canManageSampleDefinitions
                                      pTooltip="Edit sample type"
                                      tooltipPosition="left"
                                      (click)="this.editSampleType(sampleType)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      canManageSampleDefinitions
                                      pTooltip="Delete sample type"
                                      tooltipPosition="left"
                                      (click)="this.deleteSampleType(sampleType)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Sample Types" icon="pi pi-download" (click)="this.exportSampleTypes()"
              severity="secondary"></p-button>
</div>

<!-- Create Sample Type Dialog -->
<app-create-sample-type-dialog
        [(visible)]="this.displayCreateSampleTypeDialog"
        (sampleTypeCreated)="this.reloadSampleTypes()"
></app-create-sample-type-dialog>

<!-- Update Sample Type Dialog -->
<app-update-sample-type-dialog
        [(visible)]="this.displayUpdateSampleTypeDialog"
        [sampleType]="this.selectedSampleType"
        (sampleTypeUpdated)="this.reloadSampleTypes()"
></app-update-sample-type-dialog>
